/* eslint-disable @typescript-eslint/no-unused-vars */
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// NGRX
import { Store } from '@ngrx/store';
// RxJS
import { of } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

// AppState
import { AppState } from '../../../../core/reducers';
import { SetFinancialFilters } from '../../../../core/ronex';
import { UserwfdService } from '../../../../core/ronex/_services/userwfd.service';

@Component({
  selector: 'kt-no-cod-users',
  templateUrl: './no-cod-users.component.html',
  styleUrls: ['./no-cod-users.component.scss'],
})
export class NoCodUsersComponent implements OnInit {
  udata: Array<any>;
  err = false;
  displayedColumns = [
    'user',
    'kap',
    'PROCESSED',
    'RETURNED',
    'PAID',
    'PAID_APPROVED',
  ];
  loading = true;

  constructor(
    private userv: UserwfdService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private router: Router
  ) {}

  ngOnInit() {
    this.fetchData();
  }

  fetchData() {
    this.loading = true;
    this.err = false;
    this.userv
      .getNoCodUsers()
      .pipe(
        take(1),
        tap(res => (this.udata = res)),
        tap(res => (this.loading = false)),
        tap(res => this.cdr.detectChanges()),
        catchError(err => {
          this.err = true;
          this.loading = false;
          this.cdr.detectChanges();
          return of(null);
        })
      )
      .subscribe();
  }

  viewUser(usr: any) {
    this.store.dispatch(
      new SetFinancialFilters({
        filters: {
          filter: {
            uids: [usr.id],
          },
          sortOrder: 'desc',
          sortField: 'date_created',
          pageNumber: 0,
          pageSize: 50,
          for_staff: true,
        },
      })
    );
    this.router.navigateByUrl('/shipment-management/admin/shipments/financial');
  }
}
